import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { timer } from 'rxjs';
import { OverallReport, ReportLine } from 'projects/app-misc/src/app/modules/reports/data/overall-report-page';
import { SystemReportsStore } from 'projects/app-misc/src/app/modules/reports/data/system-reports.store';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import { LocalStorage } from 'ngx-webstorage';

@Component({
  selector: 'app-project-overall-price-table',
  templateUrl: './project-overall-price-table.component.html',
  styleUrls: ['./project-overall-price-table.component.scss']
})
export class ProjectOverallPriceTableComponent implements OnInit {

  @Input()
  reportLines: ReportLine[];

  @Input()
  project: ShortProject;

  @Input()
  canBeEdited: boolean;

  @Output()
  itemEdited = new EventEmitter<void>()

  @Output()
  addLine = new EventEmitter<ReportLine>();

  @LocalStorage()
  ordersProjectId: number;

  clickableSet = new Set()

  lastInput: HTMLInputElement;

  constructor(
    protected el: ElementRef,
    public router: Router,
    protected systemReportsStore: SystemReportsStore
  ) {
  }

  ngOnInit(): void {
    this.fillMap()
  }

  fillMap() {
    this.clickableSet.add('Materials')
    this.clickableSet.add('Direct Labor')
  }

  roundNum(num: number) {
    return Math.floor(num * 100) / 100
  }

  clickOnEditableCell(event: MouseEvent) {
    // event.srcElement

    const fInput = (this.el.nativeElement.getElementsByClassName('material-input-text') as HTMLInputElement)

    timer(1).subscribe(emit => {
      fInput[0].select()
    })


  }

  clickOnCab(fieldName: 'Materials' | 'Direct Labor') {
    console.log('EMIT')
    if(fieldName === 'Materials') {
      this.ordersProjectId = this.project.id
      this.router.navigate(['/orders/list'])
    } else if(fieldName === 'Direct Labor') {
      this.systemReportsStore.updateSearchQuery(this.project.name)
      this.router.navigate(['/reports/complexity/projects'])
    }
  }

  startEdit(event) {

    const tempInputs = (this.el.nativeElement as HTMLInputElement).getElementsByClassName('material-input-text');
    if(tempInputs) {
      timer(1).subscribe(emit => {
        this.lastInput = tempInputs[0] as HTMLInputElement
        if(this.lastInput) {
          this.lastInput.focus()
          this.lastInput.setSelectionRange(0, this.lastInput.value.length);
        }
      })
    }
  }

  onEditComplete(data: ReportLine) {
    this.reportLines.forEach(item => {
      item.qty = item.qty ? parseFloat(item.qty + '') : 0
      item.price = item.price ? parseFloat(item.price + '') : 0
      item.totalPrice = item.qty * item.price
    })

    this.itemEdited.emit()
  }

  onKeyPress(event) {

    // this.orderIsEdited.next();
  }

  addItem() {
    this.reportLines.push({
      name: 'New Item',
      number: (this.reportLines[this.reportLines.length - 1]
        && this.reportLines[this.reportLines.length - 1].number)
        ? this.reportLines[this.reportLines.length - 1].number + 1 : 1,
      price: 0,
      qty: 1,
      totalPrice: 0,
      editable: true
    })

    // this.addLine.emit()

    timer(1).subscribe(emit => {
      let editableCells = this.el.nativeElement.getElementsByClassName('name-cell') as HTMLElement[]
      if(editableCells) {
        editableCells[editableCells.length - 1].click()
      }
    })
  }

  deleteLine(numberToDelete: number) {
    const index = this.reportLines.findIndex(it => it.number === numberToDelete)
    if(index > -1) {
      this.reportLines.splice(index, 1);
    }
    this.itemEdited.emit()
  }

}
